import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { FavoritesService } from '../shared/favorites.service';
import { SharedDocument, SharedDocumentList } from '../shared/shared-document';

@Component({
  selector: 'app-shared-with-me',
  templateUrl: './shared-with-me.component.html',
  styleUrls: ['./shared-with-me.component.scss']
})
export class SharedWithMeComponent implements OnInit {

  constructor(private router: Router, private favoritesService: FavoritesService) { }
  sharedDocuments: SharedDocument[];

  ngOnInit() {
    this.getSharedDocuments();
  }

  getSharedDocuments() {
    this.favoritesService.getSharedWithMeDocuments()
    .subscribe(data => {
        this.sharedDocuments = new SharedDocumentList().uiMapper(data).sharedDocuments;
    });
  }

  openDocument(document: SharedDocument) {
    this.router.navigate(['/sharedocument/' + document.sharedFileId]);
  }
}
